import { useEffect, useState } from "react";
import { Euro } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth, puedeEco } from "@/lib/auth";
import { CobroDialog } from "@/components/eco/CobroDialog";

export const ApptEco = ({ patient }) => {
  const { user } = useAuth();
  const [debe, setDebe] = useState(null);
  const [open, setOpen] = useState(false);
  const ok = puedeEco(user) && patient?.id;
  const load = () => api.get(`/patients/${patient.id}`).then((r) => setDebe((r.data.treatments || []).reduce((s, t) => s + (t.pendiente_pago || 0), 0)));
  useEffect(() => {
    if (ok) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ok, patient?.id]);
  if (!ok) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="appt-eco"
        className={`inline-flex items-center gap-1 rounded-md border px-2.5 h-9 text-xs font-medium transition-colors ${debe > 0.009 ? "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100" : "border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100"}`}>
        <Euro className="h-3.5 w-3.5" />{debe == null ? "…" : debe > 0.009 ? `Debe ${debe.toFixed(2)} € · cobrar` : "Al día · cobrar"}
      </button>
      <CobroDialog open={open} patient={patient} onClose={() => setOpen(false)} onDone={() => { setOpen(false); load(); }} />
    </>
  );
};
